import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequestFile
} from "@/helper/requests"

const state = {
  schoolchild: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getSchoolchild: state => state.schoolchild.items,
  getSchoolchildCount: state => state.schoolchild.count,
  getSchoolchildCurrentUrl: state => state.schoolchild.currentUrl,
  getSchoolchildNext: state => state.schoolchild.next,
  getSchoolchildPrev: state => state.schoolchild.prev,
  getSchoolchildDetail: state => state.schoolchild.detail,
  isLoadingSchoolchild: state => state.schoolchild.loading,
  saveSchoolchildError: state => state.schoolchild.error,
}

const actions = {
  loadSchoolchild: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.MEMBER.SCHOOLCHILD.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingSchoolchild) {
      commit('SET_SCHOOLCHILD_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_SCHOOLCHILD', data.results)
          commit('SET_SCHOOLCHILD_COUNT', data.count)
          commit('SET_SCHOOLCHILD_CURRENT_URL', url)
          commit('SET_SCHOOLCHILD_NEXT_URL', data.next)
          commit('SET_SCHOOLCHILD_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_SCHOOLCHILD_LOADING_END')
          commit('SAVE_SCHOOLCHILD_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  createSchoolchild: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.SCHOOLCHILD.CREATE()
    commit('SET_SCHOOLCHILD_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_SCHOOLCHILD_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCHOOLCHILD_LOADING_END')
        catcher(data, url)
      }
    )
  },
  simplifiedCreateSchoolchild: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.SIMPLIFIED.SCHOOLCHILD()
    commit('SET_SCHOOLCHILD_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_SCHOOLCHILD_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCHOOLCHILD_LOADING_END')
        catcher(data, url)
      }
    )
  },
  updateSchoolchild: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.SCHOOLCHILD.UPDATE()
    commit('SET_SCHOOLCHILD_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_SCHOOLCHILD_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCHOOLCHILD_LOADING_END')
        catcher(data, url)
      }
    )
  },
  // loadSchoolchildDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.SCHOOLCHILD.SCHOOLCHILD.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_SCHOOLCHILD_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_SCHOOLCHILD_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_SCHOOLCHILD: (state, value) => {
    state.schoolchild.items = value
  },
  SET_SCHOOLCHILD_DETAIL: (state, value) => {
    state.schoolchild.detail = value
  },
  SET_SCHOOLCHILD_COUNT: (state, value) => {
    state.schoolchild.count = value
  },
  SET_SCHOOLCHILD_CURRENT_URL: (state, value) => {
    state.schoolchild.currentUrl = value
  },
  SET_SCHOOLCHILD_NEXT_URL: (state, value) => {
    state.schoolchild.next = value
  },
  SET_SCHOOLCHILD_PREV_URL: (state, value) => {
    state.schoolchild.prev = value
  },
  SET_SCHOOLCHILD_LOADING: (state) => {
    state.schoolchild.loading = true
  },
  SET_SCHOOLCHILD_LOADING_END: (state) => {
    state.schoolchild.loading = false
  },
  SAVE_SCHOOLCHILD_ERROR: (state, error) => {
    state.schoolchild.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
